import {
  LENDER_WATERFALL_FACT_NAMES_BOOLEAN,
  LENDER_WATERFALL_FACT_NAMES_NUMERIC,
  LENDER_WATERFALL_FACT_NAMES_STRING,
} from "@trnsact/types-lender-waterfall";
import { z } from "zod";
import { criteriaConditionSchema } from "./model";

export enum ConditionsFieldsTypes {
  Boolean = "boolean",
  Number = "number",
  String = "string",
}

export type AllRules =
  | LENDER_WATERFALL_FACT_NAMES_BOOLEAN
  | LENDER_WATERFALL_FACT_NAMES_NUMERIC
  | LENDER_WATERFALL_FACT_NAMES_STRING;

export type CriteriaValue = z.infer<typeof criteriaConditionSchema>;
